export class ExtraInfoOption {
    constructor({
                    //attributes
                    id= null,
                    extrainfo_id= null,
                    value= "",
                } = {}) {

        //fill attributes
        this.id=id;
        this.extrainfo_id=extrainfo_id;
        this.value=value;

    }
}

export function createExtraInfoOption(data={}) {
    return Object.freeze(new ExtraInfoOption(data));
}